// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qPa-","footer":"styles_footer__1Eu6x","passCodeTooltip":"styles_passCodeTooltip__9Mx4J"};